import { PageSizeSelect } from "@/components/atoms/pagination";
import { PaginationControls } from "./PaginationControls";
import { PaginationInfo } from "./PaginationInfo";

interface TableFooterProps {
  currentPage: number;
  totalPages: number;
  totalItems: number;
  pageSize: number;
  onPageChange: (page: number) => void;
  onPageSizeChange: (size: number) => void;
  pageSizeOptions?: number[];
  isLoading?: boolean;
}

export function TableFooter({
  currentPage,
  totalPages,
  totalItems,
  pageSize,
  onPageChange,
  onPageSizeChange,
  pageSizeOptions,
  isLoading = false,
}: TableFooterProps) {
  // Hide footer if pagination is disabled (totalPages = 1 and no page size options)
  if (totalPages <= 1 && (!pageSizeOptions || pageSizeOptions.length === 0)) {
    return null;
  }
  
  return (
    <div className="flex flex-col gap-4 border-t p-4 sm:flex-row sm:items-center sm:justify-between">
      <div className="flex items-center gap-2 sm:gap-4">
        <span className="text-sm text-muted-foreground">
          Filas:
        </span>
        <PageSizeSelect
          value={pageSize}
          onChange={onPageSizeChange}
          options={pageSizeOptions}
          disabled={isLoading}
        />
      </div>

      <div className="flex flex-col items-center gap-2 sm:flex-row sm:gap-4">
        <PaginationInfo
          currentPage={currentPage}
          totalPages={totalPages}
          totalItems={totalItems}
          pageSize={pageSize}
          isLoading={isLoading}
        />
        <PaginationControls
          currentPage={currentPage}
          totalPages={totalPages}
          onPageChange={onPageChange}
          isLoading={isLoading}
        />
      </div>
    </div>
  );
}
